// FIRST GO-LIVE LINK (James 2026-10-14): the first time a page goes live, show its link and let it be changed
// before anyone has it ("tedlassoseason3appletvoriginalseriessoundtrack" is too long). One step for the grid's
// Live toggle (releases-page.js confirmLiveToggle) and the editor's Live switch (visual-editor.js publishDraft):
//   LLFirstLiveLink.ask(id) → Promise: null  = not its first time (the caller confirms as before)
//                                      true  = confirmed, slug saved if changed (the caller goes live)
//                                      false = cancelled
// A page that has been live keeps its link: changing it then is the Rename / Slug field's job (old one redirects).
(function () {
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function domain() { return (window.PREVIEW_CONFIG && window.PREVIEW_CONFIG.productionDomain) || 'loud.link'; }
  // Same shape every slug takes (LoudLink.generateSlugFromString): lowercase letters and digits, no hyphens.
  function clean(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, ''); }

  function ask(id) {
    return fetch('/loudlinks/' + encodeURIComponent(id) + '/quick-preview', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (d) {
        // A page connected to an experience lives at the experience's address: no link to choose, so no prompt.
        // Nor for an experience's own card: it's reached at its PAGE's address (James 2026-10-30).
        if (!d || !d.success || d.ever_live || d.is_root || d.connected || d.experience || !d.slug || !d.artist_slug) return null;
        return open(id, d);
      });
  }

  function open(id, d) {
    return new Promise(function (resolve) {
      var host = d.artist_slug + '.' + domain() + '/';
      var overlay = document.createElement('div');
      overlay.className = 'delete-modal-overlay is-visible';
      overlay.innerHTML =
        '<div class="delete-modal ll-firstlive">' +
          '<div class="delete-modal-icon" style="color:#F3FF69;"><i class="bi bi-link-45deg"></i></div>' +
          '<p class="delete-modal-title">Your page’s link</p>' +
          '<p class="delete-modal-text"><span class="delete-modal-name">' + esc(d.title || 'This page') + '</span> goes live here. Change it now, before anyone has it.</p>' +
          '<label class="ll-firstlive-field"><span class="ll-firstlive-host">' + esc(host) + '</span>' +
            '<input type="text" class="ll-firstlive-input" value="' + esc(d.slug) + '" spellcheck="false" autocomplete="off" aria-label="Link"></label>' +
          '<p class="ll-firstlive-error" hidden></p>' +
          '<div class="delete-modal-buttons">' +
            '<button type="button" class="delete-modal-btn delete-modal-btn-cancel" data-confirm style="width:100%;">Go live</button>' +
            '<button type="button" class="delete-modal-btn delete-modal-btn-cancel" data-cancel>Cancel</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);
      var input = overlay.querySelector('.ll-firstlive-input');
      var err = overlay.querySelector('.ll-firstlive-error');
      var btn = overlay.querySelector('[data-confirm]');
      var done = false;
      function finish(v) { if (done) return; done = true; overlay.remove(); document.removeEventListener('keydown', onKey); resolve(v); }
      function onKey(e) { if (e.key === 'Escape') finish(false); }
      function fail(msg) { err.textContent = msg; err.hidden = false; btn.disabled = false; btn.textContent = 'Go live'; input.focus(); }
      input.addEventListener('input', function () {
        var c = clean(input.value);
        if (c !== input.value) { var at = input.selectionStart - (input.value.length - c.length); input.value = c; try { input.setSelectionRange(at, at); } catch (_) {} }
        err.hidden = true;
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); btn.click(); } });
      overlay.addEventListener('click', function (e) { if (window.overlayDismissClick ? window.overlayDismissClick(e, overlay) : e.target === overlay) finish(false); });
      overlay.querySelector('[data-cancel]').addEventListener('click', function () { finish(false); });
      document.addEventListener('keydown', onKey);
      btn.addEventListener('click', function () {
        var slug = clean(input.value);
        if (!slug) { fail('Enter a link for this page.'); return; }
        if (slug === d.slug) { finish(true); return; }
        btn.disabled = true; btn.textContent = 'Saving…';
        fetch('/loudlinks/' + encodeURIComponent(id) + '/slug', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ slug: slug })
        })
          .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok || !res.j.success) { fail(res.j.error || 'That link can’t be used. Try another.'); return; }
            try { document.dispatchEvent(new CustomEvent('ll:slug-changed', { detail: { id: Number(id), slug: res.j.slug || slug } })); } catch (_) {}
            finish(true);
          })
          .catch(function () { fail('Something went wrong. Try again.'); });
      });
      setTimeout(function () { input.focus(); input.select(); }, 30);
    });
  }

  window.LLFirstLiveLink = { ask: ask };
})();
